module.exports = __webpack_public_path__ + "img/search-default.2b41ce5d.svg";